import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { MessageTemplate, toMessageTemplateXml } from '../../dataObjects/MessageTemplate';

export interface INewMessageTemplateRequest extends IBaseRequest {
  resultSystemId?: string;
  messageTemplate?: MessageTemplate;
}
export class NewMessageTemplateRequest extends BaseRequest implements INewMessageTemplateRequest {
  public resultSystemId?: string;
  public messageTemplate?: MessageTemplate;

  constructor(server: string, session: string, otherOptions: any) {
    super(server, session);
    this.resultSystemId = otherOptions.resultSystemId;
    this.messageTemplate = otherOptions.messageTemplate;
  }

  public toXml(): string {
    let parameters: string = super.toXml();
    if (this.messageTemplate) parameters += toMessageTemplateXml(this.messageTemplate);
    return super.wrapperXml('NewMessageTemplate', parameters);
  }
}
